export default "__VITE_ASSET__BqTX3_rS__"